import { render, staticRenderFns } from "./EvrakGuncelle.vue?vue&type=template&id=bc9b9dfc&"
import script from "./EvrakGuncelle.vue?vue&type=script&lang=js&"
export * from "./EvrakGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./EvrakGuncelle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports